import { supabase } from '@/integrations/supabase/client';

export interface ChangeAudit {
  changed_by: string;
  changed_property: string;
  changed_from: string | null;
  changed_to: string | null;
}

export class AuditService {
  /**
   * Logs a change to the change_audits table
   * @param auditData The change audit data to log
   * @returns The created audit record
   */
  static async logChange(auditData: ChangeAudit) {
    const { data, error } = await supabase
      .from('change_audits')
      .insert([auditData])
      .select()
      .single();

    if (error) {
      throw new Error(`Failed to log change audit: ${error.message}`);
    }

    return data;
  }
} 